(function () {
  'use strict';

  var SELECTOR = '[data-centered-card-carousel]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function CenteredCardCarousel(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-ccc-viewport]');
    this.track = root.querySelector('[data-ccc-track]');
    this.prevBtn = root.querySelector('[data-ccc-prev]');
    this.nextBtn = root.querySelector('[data-ccc-next]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-ccc-dot]'));
    this.originalSlides = Array.prototype.slice.call(root.querySelectorAll('[data-ccc-slide]'));
    this.slides = this.originalSlides.slice();
    this.count = this.originalSlides.length;
    this.index = 0;
    this.loop = root.getAttribute('data-loop') === 'true' && this.count > 1;
    this.autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && this.count > 1;
    this.autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    this.enableDrag = root.getAttribute('data-enable-drag') !== 'false' && this.count > 1;
    this.timer = null;
    this.wrapHandler = null;
    this.animationTimer = null;
    this.intersectionObserver = null;
    this.isInViewport = typeof window.IntersectionObserver === 'undefined';
    this.hovering = false;
    this.dragging = false;
    this.dragMoved = false;
    this.dragStartX = 0;
    this.dragDelta = 0;
    this.startTranslate = 0;
    this.bound = {};
    this.resizeObserver = null;
    this.headerTitle = root.querySelector('[data-ccc-header-title]');
    this.headerSubtitle = root.querySelector('[data-ccc-header-subtitle]');

    if (!this.viewport || !this.track || !this.count) return;

    this.setupClones();
    this.bind();
    this.goTo(0, false);
    this.root.classList.add('is-ready');
    this.startAutoplay();
  }

  CenteredCardCarousel.prototype.setupClones = function () {
    this.clearClones();
    if (!this.loop) {
      this.slides = this.originalSlides.slice();
      return;
    }

    var first = this.originalSlides[0].cloneNode(true);
    var last = this.originalSlides[this.count - 1].cloneNode(true);
    first.setAttribute('data-clone', 'true');
    last.setAttribute('data-clone', 'true');
    first.removeAttribute('id');
    last.removeAttribute('id');
    first.removeAttribute('data-shopify-editor-block');
    last.removeAttribute('data-shopify-editor-block');
    first.classList.remove('is-active');
    last.classList.remove('is-active');
    first.setAttribute('aria-hidden', 'true');
    last.setAttribute('aria-hidden', 'true');

    var firstLink = first.querySelector('a');
    var lastLink = last.querySelector('a');
    if (firstLink) firstLink.setAttribute('tabindex', '-1');
    if (lastLink) lastLink.setAttribute('tabindex', '-1');

    this.track.insertBefore(last, this.track.firstChild);
    this.track.appendChild(first);
    this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-ccc-slide]'));
  };

  CenteredCardCarousel.prototype.clearClones = function () {
    var clones = this.track.querySelectorAll('[data-clone="true"]');
    for (var i = 0; i < clones.length; i += 1) {
      clones[i].parentNode.removeChild(clones[i]);
    }
  };

  CenteredCardCarousel.prototype.trackIndex = function (realIndex) {
    return this.loop ? realIndex + 1 : realIndex;
  };

  CenteredCardCarousel.prototype.getGap = function () {
    var style = window.getComputedStyle(this.track);
    return parseFloat(style.columnGap || style.gap) || 0;
  };

  CenteredCardCarousel.prototype.getSpan = function () {
    if (!this.slides.length) return 0;
    return this.slides[0].offsetWidth + this.getGap();
  };

  CenteredCardCarousel.prototype.getTranslateFor = function (trackIndex) {
    var slide = this.slides[trackIndex];
    if (!slide) return 0;
    var viewportWidth = this.viewport.clientWidth;
    var slideWidth = slide.offsetWidth;
    var span = this.getSpan();
    return viewportWidth / 2 - slideWidth / 2 - trackIndex * span;
  };

  CenteredCardCarousel.prototype.setTranslate = function (value, animate) {
    var reduce = prefersReducedMotion();
    var shouldAnimate = animate && !reduce;

    this.track.style.transition = shouldAnimate ? 'transform 0.45s ease' : 'none';

    if (this.animationTimer) {
      window.clearTimeout(this.animationTimer);
      this.animationTimer = null;
    }

    if (shouldAnimate) {
      var self = this;
      this.track.style.willChange = 'transform';
      this.animationTimer = window.setTimeout(function () {
        self.track.style.willChange = '';
        self.animationTimer = null;
      }, 500);
    } else {
      this.track.style.willChange = '';
    }

    this.track.style.transform = 'translate3d(' + value + 'px, 0, 0)';
  };

  CenteredCardCarousel.prototype.setMultilineHtml = function (el, text) {
    if (!el) return;
    el.textContent = '';
    var value = text == null ? '' : String(text);
    if (!value) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var parts = value.split('\n');
    for (var i = 0; i < parts.length; i += 1) {
      if (i > 0) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(parts[i]));
    }
  };

  CenteredCardCarousel.prototype.updateHeader = function () {
    var slide = this.originalSlides[this.index];
    if (!slide) return;

    var title = slide.getAttribute('data-header-title') || '';
    var subtitle = slide.getAttribute('data-header-subtitle') || '';

    if (this.headerTitle) {
      this.headerTitle.textContent = title;
      this.headerTitle.hidden = !title;
    }
    this.setMultilineHtml(this.headerSubtitle, subtitle);

    this.root.classList.toggle('has-title', !!title);
    this.root.classList.toggle('has-subtitle', !!subtitle);
  };

  CenteredCardCarousel.prototype.updateState = function (visibleTrackIndex) {
    var self = this;
    var visible = typeof visibleTrackIndex === 'number' ? visibleTrackIndex : this.trackIndex(this.index);
    this.slides.forEach(function (slide, trackIndex) {
      var isClone = slide.getAttribute('data-clone') === 'true';
      var active = trackIndex === visible;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active && !isClone ? 'false' : 'true');
      var link = slide.querySelector('a');
      if (link && !isClone) {
        if (active) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      }
    });

    this.dots.forEach(function (dot, i) {
      var active = i === self.index;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    this.updateHeader();

    if (!this.loop) {
      if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index >= this.count - 1;
    } else {
      if (this.prevBtn) this.prevBtn.disabled = false;
      if (this.nextBtn) this.nextBtn.disabled = false;
    }
  };

  CenteredCardCarousel.prototype.goTo = function (realIndex, animate) {
    if (!this.count) return;
    var nextIndex = realIndex;
    if (this.loop) {
      nextIndex = (realIndex + this.count) % this.count;
    } else {
      nextIndex = Math.max(0, Math.min(this.count - 1, realIndex));
    }

    this.index = nextIndex;
    this.setTranslate(this.getTranslateFor(this.trackIndex(this.index)), animate !== false);
    this.updateState();
  };

  CenteredCardCarousel.prototype.next = function () {
    if (this.loop) {
      this.goToLoopOffset(1);
      return;
    }
    this.goTo(this.index + 1, true);
    this.restartAutoplay();
  };

  CenteredCardCarousel.prototype.prev = function () {
    if (this.loop) {
      this.goToLoopOffset(-1);
      return;
    }
    this.goTo(this.index - 1, true);
    this.restartAutoplay();
  };

  CenteredCardCarousel.prototype.goToLoopOffset = function (offset) {
    var self = this;
    var trackIndex = this.trackIndex(this.index) + offset;
    this.index = (this.index + offset + this.count) % this.count;
    this.setTranslate(this.getTranslateFor(trackIndex), true);
    this.updateState(trackIndex);
    this.restartAutoplay();

    if (this.wrapHandler) {
      this.track.removeEventListener('transitionend', this.wrapHandler);
      this.wrapHandler = null;
    }

    if (trackIndex === 0 || trackIndex === this.slides.length - 1) {
      this.wrapHandler = function (event) {
        if (event.target !== self.track) return;
        self.track.removeEventListener('transitionend', self.wrapHandler);
        self.wrapHandler = null;
        if (trackIndex === 0) {
          self.setTranslate(self.getTranslateFor(self.trackIndex(self.count - 1)), false);
        } else {
          self.setTranslate(self.getTranslateFor(self.trackIndex(0)), false);
        }
        self.updateState();
      };
      this.track.addEventListener('transitionend', this.wrapHandler);
    }
  };

  CenteredCardCarousel.prototype.startAutoplay = function () {
    var self = this;
    this.stopAutoplay();
    if (!this.autoplayEnabled || !this.isInViewport || prefersReducedMotion() || this.hovering || this.dragging) return;
    this.timer = window.setInterval(function () {
      self.next();
    }, this.autoplaySpeed);
  };

  CenteredCardCarousel.prototype.stopAutoplay = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  CenteredCardCarousel.prototype.restartAutoplay = function () {
    this.startAutoplay();
  };

  CenteredCardCarousel.prototype.bind = function () {
    var self = this;

    this.bound.onPrev = function (event) {
      event.preventDefault();
      self.prev();
    };
    this.bound.onNext = function (event) {
      event.preventDefault();
      self.next();
    };
    this.bound.onDot = function (event) {
      var dot = event.currentTarget;
      var index = parseInt(dot.getAttribute('data-ccc-dot'), 10);
      if (!isNaN(index)) self.goTo(index, true);
      self.restartAutoplay();
    };
    this.bound.onKeydown = function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.prev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.next();
      }
    };
    this.bound.onEnter = function () {
      self.hovering = true;
      self.stopAutoplay();
    };
    this.bound.onLeave = function (event) {
      if (event.relatedTarget && self.root.contains(event.relatedTarget)) return;
      self.hovering = false;
      self.startAutoplay();
    };
    this.bound.onPointerDown = function (event) {
      if (!self.enableDrag || event.button === 2) return;
      if (event.target.closest('button')) return;
      self.dragging = true;
      self.dragMoved = false;
      self.dragStartX = event.clientX;
      self.dragDelta = 0;
      self.startTranslate = self.getTranslateFor(self.trackIndex(self.index));
      self.stopAutoplay();
      self.track.style.transition = 'none';
      self.root.classList.add('is-dragging');
      if (self.viewport.setPointerCapture) {
        try {
          self.viewport.setPointerCapture(event.pointerId);
        } catch (err) {}
      }
    };
    this.bound.onPointerMove = function (event) {
      if (!self.dragging) return;
      self.dragDelta = event.clientX - self.dragStartX;
      if (Math.abs(self.dragDelta) > 6) self.dragMoved = true;
      self.setTranslate(self.startTranslate + self.dragDelta, false);
    };
    this.bound.onPointerUp = function () {
      if (!self.dragging) return;
      self.dragging = false;
      self.root.classList.remove('is-dragging');
      var threshold = Math.max(40, self.getSpan() * 0.18);
      if (self.dragDelta > threshold) {
        self.prev();
      } else if (self.dragDelta < -threshold) {
        self.next();
      } else {
        self.goTo(self.index, true);
        self.restartAutoplay();
      }
      window.setTimeout(function () {
        self.dragMoved = false;
      }, 50);
    };
    this.bound.onClick = function (event) {
      if (self.dragMoved) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      var slide = event.target.closest('[data-ccc-slide]');
      if (!slide) return;
      var realIndex = parseInt(slide.getAttribute('data-index'), 10);
      if (!isNaN(realIndex) && realIndex !== self.index) {
        event.preventDefault();
        self.goTo(realIndex, true);
        self.restartAutoplay();
      }
    };
    this.bound.onResize = function () {
      self.goTo(self.index, false);
    };
    this.bound.onIntersection = function (entries) {
      var entry = entries[0];
      if (!entry) return;

      self.isInViewport = entry.isIntersecting;
      if (self.isInViewport) {
        self.startAutoplay();
      } else {
        self.stopAutoplay();
      }
    };

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.bound.onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.bound.onNext);
    this.dots.forEach(function (dot) {
      dot.addEventListener('click', self.bound.onDot);
    });
    this.viewport.addEventListener('keydown', this.bound.onKeydown);
    this.root.addEventListener('mouseenter', this.bound.onEnter);
    this.root.addEventListener('mouseleave', this.bound.onLeave);
    this.root.addEventListener('focusin', this.bound.onEnter);
    this.root.addEventListener('focusout', this.bound.onLeave);
    this.track.addEventListener('click', this.bound.onClick, true);

    if (this.enableDrag) {
      this.viewport.addEventListener('pointerdown', this.bound.onPointerDown);
      this.viewport.addEventListener('pointermove', this.bound.onPointerMove);
      this.viewport.addEventListener('pointerup', this.bound.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.bound.onPointerUp);
    }

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.bound.onResize);
      this.resizeObserver.observe(this.viewport);
    } else {
      window.addEventListener('resize', this.bound.onResize);
    }

    if (window.IntersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(this.bound.onIntersection, {
        threshold: 0
      });
      this.intersectionObserver.observe(this.root);
    }
  };

  CenteredCardCarousel.prototype.destroy = function () {
    this.stopAutoplay();
    if (this.animationTimer) {
      window.clearTimeout(this.animationTimer);
      this.animationTimer = null;
    }
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.bound.onPrev);
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.bound.onNext);
    var self = this;
    this.dots.forEach(function (dot) {
      dot.removeEventListener('click', self.bound.onDot);
    });
    if (this.viewport) {
      this.viewport.removeEventListener('keydown', this.bound.onKeydown);
      this.viewport.removeEventListener('pointerdown', this.bound.onPointerDown);
      this.viewport.removeEventListener('pointermove', this.bound.onPointerMove);
      this.viewport.removeEventListener('pointerup', this.bound.onPointerUp);
      this.viewport.removeEventListener('pointercancel', this.bound.onPointerUp);
    }
    this.root.removeEventListener('mouseenter', this.bound.onEnter);
    this.root.removeEventListener('mouseleave', this.bound.onLeave);
    this.root.removeEventListener('focusin', this.bound.onEnter);
    this.root.removeEventListener('focusout', this.bound.onLeave);
    this.track.removeEventListener('click', this.bound.onClick, true);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    } else {
      window.removeEventListener('resize', this.bound.onResize);
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (this.wrapHandler) {
      this.track.removeEventListener('transitionend', this.wrapHandler);
      this.wrapHandler = null;
    }
    this.clearClones();
    this.root.classList.remove('is-ready', 'is-dragging');
    this.track.style.transform = '';
    this.track.style.transition = '';
    this.track.style.willChange = '';
  };

  function initRoot(root) {
    if (!root) return;
    if (root._ccc) {
      root._ccc.destroy();
      root._ccc = null;
    }
    root._ccc = new CenteredCardCarousel(root);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i += 1) {
      initRoot(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var node = event.target.querySelector(SELECTOR);
    if (node && node._ccc) {
      node._ccc.destroy();
      node._ccc = null;
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest(SELECTOR);
    if (!root || !root._ccc) return;
    var slide = event.target.closest('[data-ccc-slide]');
    if (!slide || slide.getAttribute('data-clone') === 'true') return;
    var index = parseInt(slide.getAttribute('data-index'), 10);
    if (!isNaN(index)) root._ccc.goTo(index, false);
  });
})();
